import React from 'react';
import './App.css';

const countryFocus = [
  {
    title: 'Saudi Arabia',
    points: [
      'Property and inheritance coordination for families in Pakistan',
      'Court follow-ups and document execution without travel',
      'Dedicated contact windows aligned with KSA time',
    ],
  },
  {
    title: 'UAE (Dubai)',
    points: [
      'Fast coordination for property, tenancy, and business matters',
      'Video hearings and affidavit preparation support',
      'Update cadence tailored for UAE working hours',
    ],
  },
  {
    title: 'Canada',
    points: [
      'Remote succession and estate planning execution in Pakistan',
      'Power of attorney guidance and embassy attestation support',
      'Clear case summaries for families abroad',
    ],
  },
  {
    title: 'United States',
    points: [
      'Litigation monitoring with weekly status reporting',
      'Document verification and notarization guidance',
      'US time-zone friendly consultation slots',
    ],
  },
];

const overseasServices = [
  {
    title: 'Overseas Property & Inheritance',
    copy: 'Succession, probate, property disputes, and asset protection managed end-to-end in Pakistan.',
  },
  {
    title: 'Family & Personal Matters',
    copy: 'Discreet handling of family disputes, custody matters, and sensitive claims with remote coordination.',
  },
  {
    title: 'Corporate & Compliance Support',
    copy: 'Contract reviews, licensing, and regulatory compliance for Pakistan-based interests.',
  },
  {
    title: 'Workplace & Consumer Protection',
    copy: 'Harassment complaints, consumer claims, and representation before relevant forums in Pakistan.',
  },
];

const processSteps = [
  {
    title: '01. Remote Intake',
    copy: 'Share a short brief and documents via secure upload or email. We confirm scope and urgency.',
  },
  {
    title: '02. Strategy & Authority',
    copy: 'We provide a plan, cost estimate, and guidance for PoA or authorization if required.',
  },
  {
    title: '03. Execution in Pakistan',
    copy: 'Court appearances, filings, negotiations, and updates handled on your behalf.',
  },
  {
    title: '04. Ongoing Updates',
    copy: 'Scheduled video check-ins, written progress reports, and milestone tracking.',
  },
];

function Overseas() {
  return (
    <main className="overseas">
      <section className="section-head">
        <p className="eyebrow">Overseas Pakistanis</p>
        <h2>Legal support in Pakistan without the travel.</h2>
        <p>
          We help overseas Pakistanis resolve matters at home through structured remote workflows, clear reporting, and
          secure documentation handling.
        </p>
        <p className="response-time">Fast response: hear from us within 24 hours.</p>
      </section>

      <section className="overseas-hero">
        <div>
          <h3>Video consultation, built for global time zones.</h3>
          <p>Book a secure video session and get trusted counsel from anywhere.</p>
          <div className="video-platforms">
            <span>Zoom</span>
            <span>Google Meet</span>
            <span>WhatsApp</span>
          </div>
          <div className="video-actions">
            <a className="button" href="https://wa.me/923343161042" target="_blank" rel="noopener noreferrer">
              Book a Video Consultation
            </a>
            <a className="secondary-link" href="tel:+923343161041">
              Call +92 334 316 1041
            </a>
          </div>
        </div>
      </section>

      <section className="service-groups overseas-services">
        {overseasServices.map(({ title, copy }) => (
          <article key={title} className="panel">
            <h3>{title}</h3>
            <p>{copy}</p>
          </article>
        ))}
      </section>

      <section className="overseas-countries">
        <h3>Focused support by region</h3>
        <div className="grid">
          {countryFocus.map(({ title, points }) => (
            <article key={title} className="card">
              <h3>{title}</h3>
              <ul>
                {points.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>

      <section className="overseas-process">
        <h3>How remote matters are handled</h3>
        <div className="grid">
          {processSteps.map(({ title, copy }) => (
            <article key={title} className="panel">
              <h4>{title}</h4>
              <p>{copy}</p>
            </article>
          ))}
        </div>
      </section>

    </main>
  );
}

export default Overseas;
